import React, { useState, useEffect } from 'react';
import { Form, Button, Tooltip, Switch } from 'antd';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { ArrowRight } from '../../../assets/icons';
import { updateUserProfile } from '../../../services/authApi/userApi';
import useGetUserProfile from '../../../Hooks/useGetUserProfile';
import { toastNotify } from '../../../utils/toastNotify';
import { addUserData, addCounter } from '../../../store/reducer/accountSlice';
import { preventReload } from '../../../utils/preventReload';
import NonAccreditedModal from '../../../components/NonAccreditedModal';
import RegDModal from '../../../components/RegDModal';

const StepFour = (props) => {
  const [loading, setLoaing] = useState(false);
  const [, setIsButtonDisabled] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [isEdit, setEdit] = useState(false);
  const [isEditAccredit, setIsEditAccredit] = useState(true);
  const [isSelfAttestment, setIsSelfAttestment] = useState(false);
  const [isRegDModal, setIsRegDModal] = useState(false);
  const { userProfileData } = useGetUserProfile();
  const [uploadedDoc, setUploadedDoc] = useState({})
  const dispatch = useDispatch();

  useEffect(() => {
    if (Object.keys(userProfileData).length > 0 && Object.keys(userProfileData?.investorStatus).length > 0) {
      form.setFieldsValue({
        ...userProfileData?.investorStatus,
      });
      // setIsSelfAttestment(userProfileData?.selfAttestment);
      // setEdit(true);
      setIsButtonDisabled(false);
    }
    if (Object.keys(userProfileData).length > 0 && Object.keys(userProfileData?.investorStatus).length <= 0) {
      setIsButtonDisabled(false);
    }
    if (Object.keys(userProfileData).length > 0 && userProfileData?.accreditionDocs) {
      setUploadedDoc([
        ...userProfileData?.accreditionDocs
      ])
    }else{
      setUploadedDoc([])
    }
  }, [userProfileData]);

  useEffect(() => {
    preventReload(form);
  }, []);

  const handlerSwitch = () => {
    setIsSelfAttestment(false);
    if (isEditAccredit) {
      if (!form.getFieldValue('question5')) {
        form.setFieldsValue({
          question5: false,
        });
        setUploadedDoc({});
      } else {
        setIsRegDModal(true); // Open modal only if switch is OFF
      }
    }
  };

  const onStepFourSubmit = async (value) => {
    if (Object.values(value).includes(true) || isSelfAttestment) {
      setLoaing(true);
      const stepFourFormData = {
        investorStatus: { ...value },
        selfAttestment: isSelfAttestment,
      };
      if (value.question5) {
        stepFourFormData.investorStatus.docs = uploadedDoc;
      }
      try {
        const resp = await updateUserProfile(stepFourFormData);
        if (!resp.isError) {
          !isEdit ? props.nextAction('StepFive') : props.nextAction('StepSix');
          dispatch(addCounter(4));
          dispatch(addUserData({ userData: resp?.data?.user }));
        } else {
          toastNotify('error', resp?.message);
        }
      } catch (error) {
        const { response } = error;
        toastNotify('error', response?.data?.message);
      } finally {
        setLoaing(false);
      }
    } else {
      setModalOpen(true);
    }
  };
  const getInitialValues = () => ({
    question1: false,
    question2: false,
    question3: false,
    question4: false,
    question5: false,
  });
  return (
    <>
      <Form
        className='auth-form stepfour accredited'
        form={form}
        name='stepFourForm'
        onFinish={onStepFourSubmit}
        initialValues={getInitialValues()}
      // onFinishFailed={onFinishFailed}
      >
        <div className='accredited__list'>
          <div className='accredited__item'>
            <label
              onClick={() => isEditAccredit && setIsSelfAttestment(false)}
              htmlFor='question1'
              className={isEditAccredit ? 'accredited__item__name cursor-pointer' : 'accredited__item__name'}
            >
              I individually earn $200k+ per year, or as a joint household, equivalent to $300k+ per year.
            </label>
            <Form.Item className='mb-0' name='question1' valuePropName='checked'>
              <Switch disabled={!isEditAccredit} onClick={() => setIsSelfAttestment(false)} id='question1' />
            </Form.Item>
          </div>
          <div className='accredited__item'>
            <label
              onClick={() => isEditAccredit && setIsSelfAttestment(false)}
              htmlFor='question2'
              className={isEditAccredit ? 'accredited__item__name cursor-pointer' : 'accredited__item__name'}
            >
              My{' '}
              <Tooltip title='Net worth is the value of the assets a person or corporation owns, minus the liabilities they owe.'>
                <span className='underline cursor-pointer'>net worth</span>
              </Tooltip>{' '}
              is $1M+, excluding my primary residence.
            </label>
            <Form.Item className='mb-0' name='question2' valuePropName='checked'>
              <Switch disabled={!isEditAccredit} onClick={() => setIsSelfAttestment(false)} id='question2' />
            </Form.Item>
          </div>
          <div className='accredited__item'>
            <label
              onClick={() => isEditAccredit && setIsSelfAttestment(false)}
              htmlFor='question3'
              className={isEditAccredit ? 'accredited__item__name cursor-pointer' : 'accredited__item__name'}
            >
              Are you or a family member a senior executive or a 10% or greater share holder of a publicly traded company?
            </label>
            <Form.Item className='mb-0' name='question3' valuePropName='checked'>
              <Switch disabled={!isEditAccredit} onClick={() => setIsSelfAttestment(false)} id='question3' />
            </Form.Item>
          </div>
          <div className='accredited__item'>
            <label
              onClick={() => isEditAccredit && setIsSelfAttestment(false)}
              htmlFor='question4'
              className={isEditAccredit ? 'accredited__item__name cursor-pointer' : 'accredited__item__name'}
            >
              Are you or a family member a senior executive or a 5% or greater share holder of a company associated with a FINRA member, organization,
              or the SEC?
            </label>
            <Form.Item className='mb-0' name='question4' valuePropName='checked'>
              <Switch disabled={!isEditAccredit} onClick={() => setIsSelfAttestment(false)} id='question4' />
            </Form.Item>
          </div>
          <div className='accredited__item'>
            <label
              htmlFor='question5'
              className={isEditAccredit ? 'accredited__item__name cursor-pointer' : 'accredited__item__name'}
            >
              Would you like to complete the Regulation D accredited investor process?
            </label>
            <Form.Item className='mb-0' name='question5' valuePropName='checked'>
              <Switch
                disabled={!isEditAccredit}
                onChange={(a) => handlerSwitch(a)} id='question5' />
            </Form.Item>
          </div>
        </div>
        <Form.Item className='auth-form__fixed-submit'>
          <Button type='primary' htmlType='submit' loading={loading} className='ant-btn-primary--alt'>
            Continue <ArrowRight marginLeft='10px' verticalAlign='middle' top='-2px' />
          </Button>
        </Form.Item>
      </Form>

      {isRegDModal && (
        <RegDModal
          modalOpen={isRegDModal}
          closeModal={(value) => {
            setIsRegDModal(false)
            if (value === '1') {
              form.setFieldsValue({
                question5: false,
              });
              setUploadedDoc({});
            } else {
              form.setFieldsValue({ question5: true })
            }
          }}
          setUploadedDoc={setUploadedDoc}
        />
      )}

      <NonAccreditedModal
        modalOpen={modalOpen}
        setIsSelfAttestment={setIsSelfAttestment}
        setModalClose={setModalOpen}
        setModalOpen={(value) => {
          setIsEditAccredit(false);
          setModalOpen(value);
        }}
        isSelfAttestment={isSelfAttestment}
        onStepFourSubmit={() => onStepFourSubmit(form.getFieldsValue())}
      />
    </>
  );
};

StepFour.propTypes = {
  nextAction: PropTypes.func,
};

export default StepFour;
